import apiClient from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const _get = async (doId, queryParam) => {
  const params = {
    type: queryParam.status,
  }

  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: `/delivery-order/${doId}/history`,
    params: params,
  })

  return response?.data
}

export const get = (doId) => async (queryParam) => await _get(doId, queryParam)

const _getLog = async (doId, queryParam, queryParamFilters) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: `/delivery-order/${doId}/log`,
    params: params,
  })

  return response?.data
}

export const getLog = async (doId, queryParam, queryParamFilters) =>
  await _getLog(doId, queryParam, queryParamFilters)
